import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GenerateAccountTokenMutationVariables = Types.Exact<{
  publicToken: Types.Scalars['String']['input'];
  hrisIntegrationId: Types.Scalars['String']['input'];
}>;


export type GenerateAccountTokenMutation = { __typename?: 'Mutation', generateMergeAccountToken: { __typename?: 'BaseMutationResult', success: boolean } };

export type GenerateLinkTokenMutationVariables = Types.Exact<{
  integrationId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
}>;


export type GenerateLinkTokenMutation = { __typename?: 'Mutation', generateMergeLinkToken: { __typename?: 'GenerateLinkTokenMutationResult', value?: string | null, hrisIntegrationId?: string | null } };


export const GenerateAccountTokenDocument = gql`
    mutation GenerateAccountToken($publicToken: String!, $hrisIntegrationId: String!) {
  generateMergeAccountToken(
    publicToken: $publicToken
    hrisIntegrationId: $hrisIntegrationId
  ) {
    success
  }
}
    `;
export type GenerateAccountTokenMutationFn = Apollo.MutationFunction<GenerateAccountTokenMutation, GenerateAccountTokenMutationVariables>;

/**
 * __useGenerateAccountTokenMutation__
 *
 * To run a mutation, you first call `useGenerateAccountTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAccountTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAccountTokenMutation, { data, loading, error }] = useGenerateAccountTokenMutation({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *      hrisIntegrationId: // value for 'hrisIntegrationId'
 *   },
 * });
 */
export function useGenerateAccountTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateAccountTokenMutation, GenerateAccountTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateAccountTokenMutation, GenerateAccountTokenMutationVariables>(GenerateAccountTokenDocument, options);
      }
export type GenerateAccountTokenMutationHookResult = ReturnType<typeof useGenerateAccountTokenMutation>;
export type GenerateAccountTokenMutationResult = Apollo.MutationResult<GenerateAccountTokenMutation>;
export type GenerateAccountTokenMutationOptions = Apollo.BaseMutationOptions<GenerateAccountTokenMutation, GenerateAccountTokenMutationVariables>;
export const GenerateLinkTokenDocument = gql`
    mutation GenerateLinkToken($integrationId: UUID) {
  generateMergeLinkToken(integrationId: $integrationId) {
    value
    hrisIntegrationId
  }
}
    `;
export type GenerateLinkTokenMutationFn = Apollo.MutationFunction<GenerateLinkTokenMutation, GenerateLinkTokenMutationVariables>;

/**
 * __useGenerateLinkTokenMutation__
 *
 * To run a mutation, you first call `useGenerateLinkTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateLinkTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateLinkTokenMutation, { data, loading, error }] = useGenerateLinkTokenMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useGenerateLinkTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateLinkTokenMutation, GenerateLinkTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateLinkTokenMutation, GenerateLinkTokenMutationVariables>(GenerateLinkTokenDocument, options);
      }
export type GenerateLinkTokenMutationHookResult = ReturnType<typeof useGenerateLinkTokenMutation>;
export type GenerateLinkTokenMutationResult = Apollo.MutationResult<GenerateLinkTokenMutation>;
export type GenerateLinkTokenMutationOptions = Apollo.BaseMutationOptions<GenerateLinkTokenMutation, GenerateLinkTokenMutationVariables>;